import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchSideNavBarData } from './app-drawer-api';

// getting the side navbar data
const getSideNavBarData = createAsyncThunk(
  'getSideNavBarData',
  async ({ sourceID }: { sourceID: number }) => {
    const response = await fetchSideNavBarData(sourceID);
    return response;
  }
);

export {
  // eslint-disable-next-line import/prefer-default-export
  getSideNavBarData
};
